"use client";

import React from "react";
import { Facebook, Instagram, Loader as Loader2 } from 'lucide-react';
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
interface SocialLink {
  id: number;
  name: string;
  icon: "facebook" | "instagram";
  href: string;
}
const socialLinks: SocialLink[] = [{
  id: 1,
  name: "Facebook",
  icon: "facebook",
  href: "#"
}, {
  id: 2,
  name: "Instagram",
  icon: "instagram",
  href: "#"
}];
function NewsletterFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-start gap-3 rounded-lg border border-border bg-card p-4 text-card-foreground shadow-xs">
        <p className="text-sm font-medium text-primary">
          {successMessage || "¡Gracias por suscribirte a nuestra lista de correo!"}
        </p>
        <Button type="button" onClick={resetForm} variant="outline" size="sm" className="text-xs">
          Suscribir otro correo
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="w-full">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start">
        <div className="flex-1">
          <FormField control={control} name="email" rules={{
          required: "El correo electrónico es obligatorio",
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Por favor ingresa un correo electrónico válido"
          }
        }} render={({
          field
        }) => <FormItem className="space-y-1">
                <FormControl>
                  <Input type="email" placeholder="Dirección de correo" aria-label="Dirección de correo" className="h-11 rounded-md border-border bg-background px-4 text-foreground placeholder:text-muted-foreground focus-visible:ring-primary shadow-xs" {...field} />
                </FormControl>
                <FormMessage className="text-xs text-destructive" />
              </FormItem>} />
        </div>

        <Button type="submit" disabled={isSubmitting} className="h-11 px-8 font-semibold rounded-md bg-primary text-primary-foreground shadow-xs hover:bg-primary/90 transition-colors">
          {isSubmitting ? <>
              <Loader2 className="mr-2 size-4 animate-spin" />
              <span>Enviando...</span>
            </> : "Enviar"}
        </Button>
      </div>

      {submitError && <div className="mt-2 rounded-md border border-destructive/20 bg-destructive/10 p-2.5 text-xs text-destructive">
          {submitError}
        </div>}
    </Form>;
}
export default function Newsletter() {
  const shouldReduceMotion = useReducedMotion();
  return;
}